import { useEffect, useRef, useState } from 'react';
import { useLeftSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import { usePageVisibility } from '@atlassian/jira-use-page-visibilty-controller/src/index.tsx';

const WAIT_DURATION = 5000;

/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */
const PageDwellAnalyticsListener = () => {
	const [hasFired, setHasFired] = useState(false);

	const route = useCurrentRoute();
	const routeName = route.name;

	const [{ isReady }] = useSpaStatePageReady();
	const isVisible = usePageVisibility();
	const interval = useRef<unknown>(null);
	const { data: projectData } = useProjectContext();

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { isCollapsed: isLeftSidebarCollapsed } = useLeftSidebarState();

	useEffect(() => {
		setHasFired(false);
	}, [routeName]);

	useEffect(() => {
		if (!isReady) {
			interval.current = null;
			return;
		}

		// If the page is visible, set the analytics event to run after the specified duration
		if (isVisible && !hasFired) {
			interval.current = setTimeout(() => {
				fireTrackAnalytics(createAnalyticsEvent({}), 'page dwelled', routeName, {
					containerId: projectData?.projectId,
					containerType: projectData?.projectType,
					isLeftSidebarCollapsed,
				});

				setHasFired(true);
			}, WAIT_DURATION);
		}

		return () => {
			// @ts-expect-error - TS2769 - No overload matches this call.
			interval.current = clearTimeout(interval.current);
		};
	}, [
		createAnalyticsEvent,
		hasFired,
		isReady,
		isVisible,
		routeName,
		projectData?.projectId,
		projectData?.projectType,
		isLeftSidebarCollapsed,
	]);

	return null;
};

export { PageDwellAnalyticsListener };
